import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import taxiTaxiContractListingUserPermissionDefinition from "./taxi-taxi-contract-listing-user-permission";

const useTaxiTaxiContractListingUserPermissions = () => {
  return useUserPermissions(taxiTaxiContractListingUserPermissionDefinition);
};

export default useTaxiTaxiContractListingUserPermissions;
